import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><h1 class=\"anchor fw-bolder mb-5\"><a href=\"#input\"></a> Input </h1><div class=\"py-5\"> A group of options for multiple choices. </div><div class=\"py-5\"><div class=\"rounded py-5 px-5 bg-light-danger\"><div class=\"my-5\"> Input is a controlled component, it <b>always shows Vue binding value.</b></div><div class=\"my-5\"> Under normal circumstances, <code>input</code> event should be handled. Its handler should update component&#39;s binding value (or use <code>v-model</code>). Otherwise, input box&#39;s value will not change. </div><div class=\"my-5\">Do not support <code>v-model</code> modifiers.</div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabled = _resolveComponent("EUIDisabled")
  const _component_EUIClearable = _resolveComponent("EUIClearable")
  const _component_EUIPasswordBox = _resolveComponent("EUIPasswordBox")
  const _component_EUIInputWithIcon = _resolveComponent("EUIInputWithIcon")
  const _component_EUITextarea = _resolveComponent("EUITextarea")
  const _component_EUIAutosizeTextarea = _resolveComponent("EUIAutosizeTextarea")
  const _component_EUIMixedInput = _resolveComponent("EUIMixedInput")
  const _component_EUISizes = _resolveComponent("EUISizes")
  const _component_EUIAutocomplete = _resolveComponent("EUIAutocomplete")
  const _component_EUICustomTemplate = _resolveComponent("EUICustomTemplate")
  const _component_EUIRemoteSearch = _resolveComponent("EUIRemoteSearch")
  const _component_EUILimitLength = _resolveComponent("EUILimitLength")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabled),
    _createVNode(_component_EUIClearable),
    _createVNode(_component_EUIPasswordBox),
    _createVNode(_component_EUIInputWithIcon),
    _createVNode(_component_EUITextarea),
    _createVNode(_component_EUIAutosizeTextarea),
    _createVNode(_component_EUIMixedInput),
    _createVNode(_component_EUISizes),
    _createVNode(_component_EUIAutocomplete),
    _createVNode(_component_EUICustomTemplate),
    _createVNode(_component_EUIRemoteSearch),
    _createVNode(_component_EUILimitLength)
  ], 64))
}